import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const { isDark } = useTheme();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          // Exchange session_id for user data
          const result = await loginWithGoogle(sessionId);
          
          if (result.success) {
            // Clear the hash and navigate to quiz
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/quiz', { replace: true, state: { user: result.user } });
          } else {
            console.error('Google auth failed:', result.error);
            navigate('/auth', { replace: true });
          }
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/auth', { replace: true });
        }
      } else {
        // No session_id found, redirect to auth
        navigate('/auth', { replace: true });
      }
    };

    processAuth();
  }, [navigate, loginWithGoogle]);

  return (
    <div className={`min-h-screen flex items-center justify-center ${isDark ? 'bg-stone-950' : 'bg-stone-50'}`}>
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className={`text-lg ${isDark ? 'text-stone-300' : 'text-stone-600'}`}>
          Completing sign in...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
